/** Only allow local admin destinations after administrator sign-in. */
export function adminReturnPath(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/") || /[\\\s]/.test(value)) {
    return "/admin";
  }
  try {
    const url = new URL(value, "https://stylistaward.com");
    if (
      url.origin !== "https://stylistaward.com" ||
      (url.pathname !== "/admin" && !url.pathname.startsWith("/admin/"))
    ) {
      return "/admin";
    }
    return url.pathname + url.search + url.hash;
  } catch {
    return "/admin";
  }
}
